/**
 * Mimesa's access model, the fallback the admin uses when the API sends no role permissions
 * (it normally does, from the "Permisos" console). Mirrors the defaults in
 * mimesa/service/services/permission.service.js.
 */
const ALL_SCREENS = [
    'dashboard',
    'notifications',
    'clients',
    'stores',
    'users',
    'price',
    'products',
    'categories',
    'segments',
    'tags',
    'activity-logs',
    'promoters',
    'promoters-analytics',
    'contracts',
    'campaigns',
    'polls',
];

const MIMESA_ACCESS = Object.freeze({
    // Screens per role when the API sent none. admin always has everything.
    roleScreens: Object.freeze({
        gerente: ALL_SCREENS,
        asesor: ['dashboard', 'clients', 'stores', 'price', 'activity-logs', 'promoters', 'promoters-analytics', 'contracts', 'campaigns'],
        client: ['my-client', 'stores', 'promoters'],
    }),
    // Actions per role when the API sent none.
    roleActions: Object.freeze({
        gerente: ['data.export', 'clients.create', 'users.manage-all-roles'],
        asesor: ['data.export'],
        client: ['data.export'],
    }),
    // The "Permisos" console follows this action instead of being admin-only.
    permissionsAction: 'permissions.manage',
    // A user without the dashboard lands on the first screen they may open.
    homeToFirstScreen: true,
});

export default MIMESA_ACCESS;
